export const ORDER_RESET = '@@mah-maps/ORDER_RESET';
export const ORDER_CALCULATED = '@@mah-maps/ORDER_CALCULATED';
export const ORDER_CALCULATION_FAILED = '@@mah-maps/ORDER_CALCULATION_FAILED';
export const ORDER_CLEAN_CALCULATION_ERRORS = '@@mah-maps/ORDER_CLEAN_CALCULATION_ERRORS';
export const CHECK_IN_PAYMENT_SUCCESS = '@@mah-maps/CHECK_IN_PAYMENT_SUCCESS';